import { createContext } from "react";

export const ScannerContext = createContext(null);
